export var EventModuleTypesEnum;
(function (EventModuleTypesEnum) {
    EventModuleTypesEnum["DELIVERY"] = "delivery";
    EventModuleTypesEnum["CONTRACT"] = "contract";
    EventModuleTypesEnum["INVENTORY"] = "inventory";
    EventModuleTypesEnum["FARM"] = "farm";
    EventModuleTypesEnum["STORAGELOCATION"] = "storage";
    EventModuleTypesEnum["CONNECTION"] = "connection";
    EventModuleTypesEnum["DELIVERYLOCATION"] = "location";
    EventModuleTypesEnum["TEAMMEMBER"] = "teammember";
    EventModuleTypesEnum["SETTING"] = "setting";
    EventModuleTypesEnum["INVOICE"] = "invoice";
    EventModuleTypesEnum["INTERNAL"] = "internal";
    EventModuleTypesEnum["ERROR"] = "error";
    EventModuleTypesEnum["AUTH"] = "auth";
    EventModuleTypesEnum["ORDER"] = "order";
    EventModuleTypesEnum["IMPORT"] = "import";
    EventModuleTypesEnum["PRICE"] = "price";
    EventModuleTypesEnum["ACCOUNT"] = "account";
    EventModuleTypesEnum["HOME"] = "home";
    EventModuleTypesEnum["FEED"] = "feed";
})(EventModuleTypesEnum || (EventModuleTypesEnum = {}));
export var EventActionTypesEnum;
(function (EventActionTypesEnum) {
    EventActionTypesEnum["TAP"] = "tap";
    EventActionTypesEnum["SWIPE"] = "swipe";
    EventActionTypesEnum["SCROLL"] = "scroll";
    EventActionTypesEnum["CLICK"] = "click";
    EventActionTypesEnum["DOUBLECLICK"] = "double_click";
    EventActionTypesEnum["DRAGANDDROP"] = "drag_and_drop";
    EventActionTypesEnum["RIGHTCLICK"] = "right_click";
    EventActionTypesEnum["LOAD"] = "load";
    EventActionTypesEnum["API"] = "api";
})(EventActionTypesEnum || (EventActionTypesEnum = {}));
export var EventActionsEnum;
(function (EventActionsEnum) {
    EventActionsEnum["CREATE"] = "create";
    EventActionsEnum["UPDATE"] = "update";
    EventActionsEnum["EDIT"] = "edit";
    EventActionsEnum["DELETE"] = "delete";
    EventActionsEnum["CANCEL"] = "cancel";
    EventActionsEnum["COMPLETE"] = "complete";
    EventActionsEnum["VIEW"] = "view";
    EventActionsEnum["PRINT"] = "print";
    EventActionsEnum["REVERT"] = "revert";
    EventActionsEnum["SUBMIT"] = "submit";
    EventActionsEnum["EXPORT"] = "export";
    EventActionsEnum["TOGGLE"] = "toggle";
    EventActionsEnum["COPY"] = "copy";
    EventActionsEnum["DOWNLOAD"] = "download";
    EventActionsEnum["UPLOAD"] = "upload";
    EventActionsEnum["SYNC"] = "sync";
    EventActionsEnum["SEARCH"] = "search";
})(EventActionsEnum || (EventActionsEnum = {}));
export var EventViewTypesEnum;
(function (EventViewTypesEnum) {
    EventViewTypesEnum["LIST"] = "list";
    EventViewTypesEnum["DETAIL"] = "detail";
    EventViewTypesEnum["FORM"] = "form";
    EventViewTypesEnum["MODAL"] = "modal";
    EventViewTypesEnum["NONE"] = "none";
})(EventViewTypesEnum || (EventViewTypesEnum = {}));
//# sourceMappingURL=enum.js.map